class SelectFieldController {

    $onInit() {
        this.required = this.required === undefined ? false : this.required;
    }

}

export default SelectFieldController;


// WEBPACK FOOTER //
// ./app/common/form-fields/select-field/select-field-controller.js